import { render } from "./AsyncComponentWrapper.vue?vue&type=template&id=3228f924&ts=true"
import script from "./AsyncComponentWrapper.vue?vue&type=script&lang=ts"
export * from "./AsyncComponentWrapper.vue?vue&type=script&lang=ts"

import "./AsyncComponentWrapper.vue?vue&type=style&index=0&id=3228f924&lang=stylus"

import exportComponent from "/tmp/ffsecurity-ui/packages/v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__